export default __webpack_public_path__ + "static/media/sparck-no-card.92de8090.png";